export const stateName = 'conversation' as const

export enum HarassmentWarningVariant {
  Off = 'off',
  Soft = 'a',
  Hard = 'b',
}
